var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pie-chart',{ref:"bigChart",attrs:{"height":250,"chart-data":_vm.bigBarChart.chartData,"extra-options":_vm.bigBarChart.extraOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }